import React, { Component } from "react";
import "./style.css";

import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { selectLanguage } from "./../../../redux/actions/header/action";
import { config } from "./../../../utils/domain_config";
import * as constants from "../../../utils/constants";
import { isMobioPlus } from "../../../utils/isMobio+";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarHidden: true,
      accountexists: false,
    };
  }

  handleChangeLanguage = (lang) => {
    this.props.selectLanguage(lang);
  };
  showSidebar() {
    this.setState({
      sidebarHidden: !this.state.sidebarHidden,
    });
  }

  render() {
    let countryCode = JSON.parse(sessionStorage.getItem("countryCode"));
    const uid = JSON.parse(sessionStorage.getItem("uid")).uid;

    const logo = isMobioPlus
      ? require("./../../assets/images/mobioplus_logo.svg")
      : require("./../../assets/images/Logo.png");

    let Styles = "";
    if (window.location.pathname == "/account") {
      Styles = {
        listyle: {
          display: "none",
          margin: "10px",
          marginRight: "0px",
          marginLeft: "0px",
        },
      };
    } else {
      Styles = {
        listyle: { margin: "10px", marginRight: "0px", marginLeft: "0px" },
      };
    }

    return (
      <div
        className={
          this.props.headerBackColor === "transparent" ? "header" : "header-fix"
        }
      >
        <header
          className={
            this.props.headerBackColor === "transparent"
              ? "header-withoutbg"
              : "header-withbg"
          }
        >
          <div className="brand-name">
            <span>
              <a
                href={`${
                  isMobioPlus ? `https://mobioplus.online/?uid=${uid}` : "/"
                }`}
              >
                <img
                  src={logo}
                  width={`${isMobioPlus ? "150" : "200"}`}
                  height={`${isMobioPlus ? "150" : "200"}`}
                  alt=""
                  style={{
                    marginTop: "8px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  className="logo-height-width"
                />
              </a>
            </span>
          </div>
          {countryCode.countryCode == "fr" &&
          window.location.host.split(".")[0] !== "be" &&
          window.location.host.split(".")[0] !== "dz" ? (
            <div className="my-account">
              <a
                href="http://n.mobioastro.com/fr/tnc-mobioastro?offer=1&device=pc&_next=myaccount.html"
                target="_blank"
              >
                Mon Compte
              </a>
            </div>
          ) : null}
          {(countryCode.countryCode == "explore" ||
            countryCode.countryCode == "no" ||
            countryCode.countryCode == "bh" ||
            countryCode.countryCode == "pl" ||
            countryCode.countryCode == "rs" ||
            countryCode.countryCode == "za") &&
            (window.screen.width >= 825 ? (
              <div>
                <ul
                  style={{
                    display: "flex",
                    float: "right",
                    margin: "10px 0px 0 0",
                  }}
                >
                  <li style={{ margin: "10px", marginRight: "0px" }}>
                    <Link to="/dailyLove">
                      <span
                        className={"navbt"}
                        style={{
                          fontFamily: "cursive",
                          color: "white",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage
                          id="lovetarot"
                          defaultMessage="Love Tarot"
                        />
                      </span>
                    </Link>
                  </li>
                  <li style={{ margin: "10px", marginRight: "0px" }}>
                    <Link to="/videos">
                      <span
                        className={"navbt"}
                        style={{
                          fontFamily: "cursive",
                          color: "white",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage
                          id="lovetarot"
                          defaultMessage="Astrology Videos"
                        />
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      margin: "10px",
                      marginRight: "0px",
                      marginLeft: "0px",
                    }}
                  >
                    <Link to="/fortuneCookie">
                      <span
                        className={"navbt"}
                        style={{
                          fontFamily: "cursive",
                          color: "white",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage
                          id="fortunecookie"
                          defaultMessage="Fortune Cookie"
                        />
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      margin: "10px",
                      marginRight: "0px",
                      marginLeft: "0px",
                    }}
                  >
                    <Link to="/numerology">
                      <span
                        className={"navbt"}
                        style={{
                          color: "white",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage
                          id="numerology"
                          defaultMessage="Numerology"
                        />
                      </span>
                    </Link>
                  </li>
                  <li style={Styles.listyle}>
                    <Link to="/account">
                      <span
                        className={"navbt"}
                        style={{
                          color: "white",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage
                          id="myacnt"
                          defaultMessage="My Account"
                        />
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            ) : (
              <div onClick={() => this.showSidebar()}>
                <img
                  src={require("./../../assets/images/hamburger-icon-white.png")}
                  alt=""
                  style={{
                    marginTop: "10px",
                    marginRight: "10px",
                    float: "right",
                  }}
                  className=""
                />
              </div>
            ))}
          {
            <div
              id="sidebar"
              style={{
                display: this.state.sidebarHidden ? "none" : "block",
                backgroundColor: "#170732",
                width: "100vw",
                height: "100vh",
                float: "right",
                transition: "0.5s",
              }}
            >
              <ul>
                <li>
                  <Link to="/videos">
                    <span
                      style={{ marginTop: "60px", cursor: "pointer" }}
                      className={"sidenavs"}
                    >
                      <FormattedMessage
                        id="lovetarot"
                        defaultMessage="Astrology Videos"
                      />
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dailyLove">
                    <span
                      style={{ marginTop: "60px", cursor: "pointer" }}
                      className={"sidenavs"}
                    >
                      <FormattedMessage
                        id="lovetarot"
                        defaultMessage="Love Tarot"
                      />
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/fortuneCookie">
                    <span
                      className={"sidenavs"}
                      style={{ marginTop: "60px", cursor: "pointer" }}
                    >
                      <FormattedMessage
                        id="fortunecookie"
                        defaultMessage="Fortune Cookie"
                      />
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/numerology">
                    <span
                      style={{ marginTop: "60px", cursor: "pointer" }}
                      className={"sidenavs"}
                    >
                      <FormattedMessage
                        id="numerology"
                        defaultMessage="Numerology"
                      />
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/account">
                    <span
                      style={{ marginTop: "60px", cursor: "pointer" }}
                      className={"sidenavs"}
                    >
                      <FormattedMessage
                        id="myacnt"
                        defaultMessage="My Account"
                      />
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          }

          {window.location.host.split(".")[0] == "be" ? (
            <div className="select-lang">
              <div className="langMenu">
                <div className="liHead">
                  <a>
                    <FormattedMessage
                      id="language"
                      defaultMessage="Languages"
                      description=""
                      values={{}}
                    />
                  </a>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "nl"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("nl")}
                  >
                    NL
                  </span>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "fr"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("fr")}
                  >
                    FR
                  </span>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "en"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("en")}
                  >
                    EN
                  </span>
                </div>
              </div>
            </div>
          ) : window.location.host.split(".")[0] == "dz" ? (
            <div className="select-lang">
              <div className="langMenu">
                <div className="liHead">
                  <a>
                    <FormattedMessage
                      id="language"
                      defaultMessage="Languages"
                      description=""
                      values={{}}
                    />
                  </a>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "fr"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("fr")}
                  >
                    FR
                  </span>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "eg"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("eg")}
                  >
                    AR
                  </span>
                </div>
              </div>
            </div>
          ) : null}
          {window.location.host.split(".")[0] === "eg" ? (
            <div className="select-lang">
              <div className="langMenu">
                <div className="liHead">
                  <a>
                    <FormattedMessage
                      id="language"
                      defaultMessage="Languages"
                      description=""
                      values={{}}
                    />
                  </a>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "en"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("en")}
                  >
                    EN
                  </span>
                </div>
                <div>
                  <span
                    className={
                      countryCode.countryCode === "eg"
                        ? "active-lang"
                        : "liButton"
                    }
                    onClick={() => this.handleChangeLanguage("eg")}
                  >
                    AR
                  </span>
                </div>
              </div>
            </div>
          ) : null}
        </header>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countryCode: state.HeaderReducer.countryCode,
    localLanguage: state.HeaderReducer.localLanguage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    selectLanguage: bindActionCreators(selectLanguage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/mobioastro/components/header/header.js